import { ActionReducerMap } from '@ngrx/store';

import { AppState } from '../states/app.state';

import * as fromRouter from '@ngrx/router-store';
import * as fromUser from '../reducers/user.reducer';
import * as fromStaticData from '../reducers/static-data.reducer';

export const reducers: ActionReducerMap<AppState> = {
  router: fromRouter.routerReducer,
  [fromUser.usersFeatureKey]: fromUser.reducer,
  [fromStaticData.staticDataFeatureKey]: fromStaticData.reducer,
};
